<template>
	<body id="poster">
		
			
				<div class="xzkm">选择科目</div>
				<!-- 步骤条 -->
				<div class="steps">
				<el-steps :active="active" >
					<el-step title="选择职业类别"></el-step>
					<el-step title="选择考试分类"></el-step>
					<el-step title="选择考试科目"></el-step>
				</el-steps>
			    </div>
				<!-- 职业类别 -->
				<div class="leibie">
					<div class="leibie-select" v-if="item.KsbClassName=='执业资格考试' || item.KsbClassName=='正高卫生职称' || item.KsbClassName=='副高卫生职称' || item.KsbClassName=='中级卫生职称' || item.KsbClassName=='初级卫生职称'"
					 :class="activelb==index?'activeb':''" v-for="(item,index) in list" @click="onKsbClassName(index,item.KsbClassID,item.Childs)">
						{{item.KsbClassName}}
						</div>
					<!-- <div class="leibie-select">正高卫生职称</div>
					<div class="leibie-select">正高卫生职称</div>
					<div class="leibie-select">正高卫生职称</div> -->
				</div>
				<!-- 考试分类 -->
				<div class="ksfenlei" v-if=" this.KsbClassID=='149' || this.KsbClassID=='150' || this.KsbClassID=='151' || 
			this.KsbClassID=='152' ||  this.KsbClassID=='153'">
					<div class="ksfenlei-select" v-for="(items,indexs) in KsbClassInfo" 
					:class="activea==indexs?'activeb':''"
					@click="onKsbClassInfo(indexs,items.KsbClassID)"
					v-if="items.PID==150 || items.PID==151 || items.PID==152 || items.PID==153">
						{{items.KsbClassName}}
						</div>
						<div class="ksfenlei-select" v-for="(aaitem,aaindex) in zhiye"
						 :class="zyactive==aaindex?'activeb':''"
						 v-if="aaitem.KsbClassID==155" @click="onKsbClassInfos(aaindex,aaitem.Childs[0].KsbClassID)">医师</div>
						<div class="ksfenlei-select" v-for="(aaitem,aaindex) in zhiye" 
						:class="zyactive==aaindex?'activeb':''"
						v-if="aaitem.KsbClassID==154" @click="onKsbClassInfos(aaindex,aaitem.KsbClassID)">护士</div>
						
						<div  v-for="(aaitem,aaindex) in zhiye" v-if="aaitem.KsbClassID==156">
							<div class="ksfenlei-select" v-for="(zyitem,zyindex) in aaitem.Childs"
							:class="zyactive==zyindex?'activeb':''"
							 v-if="zyitem.KsbClassID==374" @click="onKsbClassInfoss(zyindex,zyitem.KsbClassID)">中药药师</div>
							<div class="ksfenlei-select" v-for="(zyitem,zyindex) in aaitem.Childs" 
							:class="zyactive==zyindex?'activeb':''"
							v-if="zyitem.KsbClassID==375" @click="onKsbClassInfoss(zyindex,zyitem.KsbClassID)">西药药师</div>
						</div>
					<!-- <div class="leibie-select">正高卫生职称</div>
					<div class="leibie-select">正高卫生职称</div> -->
				</div>
				<!-- 考试科目 -->
				<div class="kskm" v-if="KsbClassInfokemu.length!=0">
					<div class="kskm-select" v-for="(itemss,indexss) in KsbClassInfokemu" @click="onKemu(indexss,itemss)">{{itemss.Name.lastIndexOf("［") == -1
						    ? itemss.Name
						    : itemss.Name.substr(0, itemss.Name.lastIndexOf("［"))}}</div>
					
				</div>
			
		
	</body>
</template>
<script>
	var that;
	 import {
	      insertBuriedPoint,
	      getKsbClass,
	      getKsbClassInfo,
		  freeFegist,
		  selectAgent
	    } from "../api/api";
	export default {
		name: "Login",
		data() {
			return {
				active: 0,
				activelb:6,
				list: [], //分类
				medata: [], //
				zhiye:[],
				KsbClassInfo: [], //科目
				KsbClassInfokemu:[],
				zyactive:'',
				activea: '9',
				KsbClassID:''
			};
		},
		created() {
			// if(JSON.parse(sessionStorage.getItem('username'))==null){
						     
			// 			    localStorage.setItem("loginData", JSON.stringify({guid:"p3MNF1NhCrK1w2gaVcvbseRir6BHPSvp1823714",userID:"1823714",userName:"游客"}));
							
			// }
		},
		mounted() {
			that = this;
			 that.getKsbClass();
			 // localStorage.setItem('agent', JSON.stringify(this.$route.name));
			 // if(JSON.parse(sessionStorage.getItem('username'))==null){
			 			 
			 // 			    localStorage.setItem("loginData", JSON.stringify({guid:"p3MNF1NhCrK1w2gaVcvbseRir6BHPSvp1823714",userID:"1823714",userName:"游客"}));
			 // 				that.guid="p3MNF1NhCrK1w2gaVcvbseRir6BHPSvp1823714"
			 			   
			 // }

			 // localStorage.setItem('agent', JSON.stringify(this.$route.name));
			 //获取localStroage值
			 that.agent = JSON.parse(localStorage.getItem('agent'));
		},
		methods: {
			// 获取职业类别
			getKsbClass(){
							// let data = {
							  
							//   KsbClassID:150
							// }
							getKsbClass().then(res => {
							  console.log("我是返回的", res);
							  that.res = '进入';
							  if (res.data.status == 200) {
								var datas = [];
								for (let index = 0; index < res.data.data.length; index++) {
									datas.push(res.data.data[index]);
								 
								}
								datas.push({
									KsbClassID: 149,
									SortID: 4,
									KsbClassName: "执业资格考试"
								})
								that.list = datas;
							    console.log("res.data.data", that.list);
							    that.medata = res.data.medata;
							    console.log("that.medata", that.medata);
							  } else {
							    return false;
							  }
							}).catch(re => {})
						},
						onKsbClassName:function(index,KsbClassID,Childs){
							this.activelb=index;
							this.active = 1;
							that.KsbClassInfokemu='';
							that.activea= '9';
							
							that.zyactive='6';
							 that.KsbClassID=KsbClassID
							 if (KsbClassID==149) {
							    
							
							var list=that.list
							that.zhiye=list
							that.KsbClassInfo = ""
							   // that.getKsbClass()
							   console.log('Childs',that.zhiye)
							 } else {
							   that.KsbClassInfo = Childs;
											
											that.zhiye=null
							 }
										
							 console.log("KsbClassID",KsbClassID)
						},
						onKsbClassInfo(indexs,KsbClassID){
							that.activea = indexs;
							this.active = 2;
							var KsbClassID = {
							  KsbClassID: KsbClassID
							};
							getKsbClassInfo(KsbClassID).then(res => {
							  if (res.data.status == 200) {
							    that.KsbClassInfokemu = res.data.data;
											  console.log("1112222",res.data.data)
							  } else {
							    return false;
							  }
							});
						},
						
						onKsbClassInfos(aaindex,KsbClassID){
							console.log("aaindex",aaindex)
							that.zyactive = aaindex;
							this.active = 2;
							var KsbClassID = {
							  KsbClassID: KsbClassID
							};
							getKsbClassInfo(KsbClassID).then(res => {
							  if (res.data.status == 200) {
							    that.KsbClassInfokemu = res.data.data;
											  console.log("1112222",res.data.data)
							  } else {
							    return false;
							  }
							});
						},
						onKsbClassInfoss(zyindex,KsbClassID){
							console.log("zyindex",zyindex)
							that.zyactive = zyindex;
							this.active = 2;
							var KsbClassID = {
							  KsbClassID: KsbClassID
							};
							getKsbClassInfo(KsbClassID).then(res => {
							  if (res.data.status == 200) {
							    that.KsbClassInfokemu = res.data.data;
											  console.log("1112222",res.data.data)
							  } else {
							    return false;
							  }
							});
						},
						onKemu(indexss,itemss){
							
							that.item=itemss;
							that.item.Name =
							  that.item.Name.lastIndexOf("［") == -1
							    ? that.item.Name
							    : that.item.Name.substr(0, that.item.Name.lastIndexOf("［"));
								this.$emit("subjects",JSON.stringify(that.item),that.item.AppID);
							that.$router.push({
							  path: '/keycaseVideo',
							  query: {
							    item: JSON.stringify(that.item),
							   code: 'subjectChoose',
							  }
							  
							})
						},
			next() {
				this.active = 1;
			},
			nexta() {
				this.active = 2;
			},
			nextb() {
				this.active = 3;
			}
		},

	};
</script>

<style scoped>
	#poster {
	/* 	height: 100%;
		
		background-color: #fdba83;
		position: fixed; */
	}

	

	body {
		margin: 0px;
		padding: 0;
	}
    #poster /deep/.el-steps--horizontal{
		width: 80%;
	}
	#poster /deep/.el-step__icon{
		width: 30px;
		height: 30px;
		

	}
	#poster /deep/ .el-step__icon.is-text{
		/* color: #6ec1fd; */
	}
	#poster /deep/ .el-step__title{
		margin-left: -30px;
		font-size: 14px;
	}
	#poster /deep/ .el-step__head.is-process {
		/* color: #1A1A1A; */
	}
	#poster /deep/.el-step__title.is-process{
		font-weight: 500;
	}
	.container {
		border-radius: 10px;
		background-clip: padding-box;
		margin: 170px auto;
		width: 850px;
		height: 500px;
		/* padding: 35px 35px 15px 35px; */
		padding-top: 20px;
		background: #fff;
		border: 1px solid #797979;
		/* box-shadow: 0 0 25px #cac6c6; */
	}
    .steps{
		margin-left: 15%;
	} 
	.xzkm {
		margin-left: 30px;
		font-size: 25px;
		font-weight: bold;
	}
	.leibie{
		/* width: 270px; */
		width: 32%;
		height: 300px;
		/* border: 1px solid #797979; */
		float: left;
	}
	.ksfenlei{
		width: 32%;
		height: 400px;
		/* border: 1px solid #797979; */
		float: left;
	}
	.kskm{
		width: 34%;
		height: 400px;
		/* border: 1px solid #797979; */
		float: left;
		overflow: auto;
	}
	.leibie-select{
		width: 100%;
		height: 45px;
		line-height: 45px;
		text-align: center;
		font-size: 15px;
		font-weight: 700;
		color: #333333;
		/* margin-bottom: 0.5px; */
		cursor: pointer;
		border: 1px solid #dadada;
		
	}
	.ksfenlei-select{
		width: 100%;
		height: 45px;
		line-height: 45px;
		text-align: center;
		font-size: 15px;
		font-weight: 700;
		color: #333333;
		/* margin-bottom: 0.5px; */
		cursor: pointer;
		border: 1px solid #dadada;
		background: #f5f5f5;
	}
	.kskm-select{
		width: 95%;
		height: 45px;
		line-height: 45px;
		text-align: center;
		font-size: 15px;
		font-weight: 700;
		color: #333333;
		/* margin-bottom: 0.5px; */
		cursor: pointer;
		border: 1px solid #dadada;
	}
	.activeb{
		color: #409eff;
	}
</style>

